import { Fragment } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

import { Breadcrumbs } from "AbstractElements";
import TheForm from "Components/Common/Component/form/TheForm";
import { useCrudApi } from "hook/useCrudApi";
import { useResourceNavigate } from "hook/useResourceNavigate";
import { LichSuThanhToan } from "models/lich-su-thanh-toan";
import { useFormFields, parent, title } from "./constant";

export const CreatePage = () => {
  const { useCreate } = useCrudApi<LichSuThanhToan>("LichSuThanhToan");
  const { toList } = useResourceNavigate("lich-su-thanh-toan");

  const { mutate: createUser } = useCreate({
    onSuccess: () => {
      toList();
      toast.success("Thêm mới thành công");
    },
    onError: (error) => {
      toast.error("Có lỗi");
    },
  });

  const { formFields } = useFormFields();
  const useFormReturn = useForm();
  const { handleSubmit } = useFormReturn;

  const onSubmit = (values) => {
    createUser({ ...values });
  };

  return (
    <Fragment>
      <Breadcrumbs title={title} parent={parent} mainTitle={title} />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardBody>
                <TheForm
                  {...useFormReturn}
                  items={formFields}
                  onSubmit={handleSubmit(onSubmit)}
                  onCancel={toList}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};
